import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dateShort'
})
export class DateShortPipe implements PipeTransform {
  transform(value: Date | string): string | null {
    const date = new Date(value);
    const locale = localStorage.getItem("lang") || navigator.language || 'en-US';
    const formatter = new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    });
    return formatter.format(date).replace(/-/g, '/');
  }
}
